// Generated from OpenAPI by pnpm gen:api. Do not edit.
export const groupOperations: ReadonlyArray<readonly [string, string]> = [
  [
    "GET",
    "/api/admin/policies-and-standards/catalogue"
  ],
  [
    "POST",
    "/api/admin/policies-and-standards/catalogue"
  ],
  [
    "GET",
    "/api/admin/policies-and-standards/catalogue/{id}/versions"
  ],
  [
    "GET",
    "/api/admin/policies-and-standards/assignments"
  ],
  [
    "POST",
    "/api/admin/policies-and-standards/assignments"
  ],
  [
    "GET",
    "/api/admin/sites/{id}/arrival-safety"
  ],
  [
    "PATCH",
    "/api/admin/sites/{id}/arrival-safety"
  ],
  [
    "GET",
    "/api/me/policies-and-standards"
  ],
  [
    "POST",
    "/api/me/policies-and-standards"
  ],
  [
    "GET",
    "/api/inventory/{level}/{id}/lifecycle"
  ],
  [
    "POST",
    "/api/inventory/{level}/{id}/lifecycle/preview"
  ],
  [
    "POST",
    "/api/inventory/{level}/{id}/lifecycle/confirm"
  ],
  [
    "GET",
    "/api/inventory/{level}/{id}/lifecycle/history"
  ],
  [
    "GET",
    "/api/inventory/lifecycle/previews/{previewId}/children"
  ],
  [
    "GET",
    "/api/inventory/lifecycle/previews/{previewId}/bookings"
  ],
  [
    "GET",
    "/api/staffed-services"
  ],
  [
    "POST",
    "/api/staffed-services"
  ],
  [
    "PATCH",
    "/api/staffed-services/{id}"
  ],
  [
    "GET",
    "/api/staffed-services/teams"
  ],
  [
    "GET",
    "/api/staffed-service-requests"
  ],
  [
    "POST",
    "/api/staffed-service-requests"
  ],
  [
    "GET",
    "/api/staffed-service-requests/team"
  ],
  [
    "POST",
    "/api/staffed-service-requests/{id}/transition"
  ],
  [
    "GET",
    "/api/dashboard/stats"
  ],
  [
    "GET",
    "/api/dashboard/timeseries"
  ],
  [
    "GET",
    "/api/auth/me"
  ],
  [
    "GET",
    "/api/admin/inventory/health"
  ],
  [
    "GET",
    "/api/admin/policies/health"
  ],
  [
    "GET",
    "/api/admin/audit-events"
  ],
  [
    "POST",
    "/api/admin/import-harbour-exchange"
  ],
  [
    "GET",
    "/api/admin/harbour-exchange/location"
  ],
  [
    "POST",
    "/api/admin/harbour-exchange/location"
  ],
  [
    "GET",
    "/api/admin/harbour-exchange/demo"
  ],
  [
    "POST",
    "/api/admin/harbour-exchange/demo"
  ],
  [
    "POST",
    "/api/admin/import-brisbane"
  ],
  [
    "GET",
    "/api/admin/users"
  ],
  [
    "POST",
    "/api/admin/users/{userId}/roles"
  ],
  [
    "DELETE",
    "/api/admin/users/{userId}/roles/{roleCode}"
  ],
  [
    "GET",
    "/api/me/manager-scope"
  ],
  [
    "GET",
    "/api/admin/managers/{managerUserId}/scope"
  ],
  [
    "PUT",
    "/api/admin/managers/{managerUserId}/scope"
  ],
  [
    "POST",
    "/api/admin/managers/{managerUserId}/reports"
  ],
  [
    "DELETE",
    "/api/admin/managers/{managerUserId}/reports/{reportUserId}"
  ],
  [
    "GET",
    "/api/inventory/site-form-options"
  ],
  [
    "GET",
    "/api/bookings/options"
  ],
  [
    "GET",
    "/api/sites"
  ],
  [
    "POST",
    "/api/sites"
  ],
  [
    "GET",
    "/api/sites/{id}"
  ],
  [
    "PATCH",
    "/api/sites/{id}"
  ],
  [
    "DELETE",
    "/api/sites/{id}"
  ],
  [
    "GET",
    "/api/sites/{id}/opening-hours"
  ],
  [
    "PUT",
    "/api/sites/{id}/opening-hours"
  ],
  [
    "GET",
    "/api/sites/{id}/induction-checklist"
  ],
  [
    "PUT",
    "/api/admin/sites/{id}/safety-config"
  ],
  [
    "GET",
    "/api/me/site-inductions"
  ],
  [
    "POST",
    "/api/me/site-inductions"
  ],
  [
    "GET",
    "/api/buildings"
  ],
  [
    "POST",
    "/api/buildings"
  ],
  [
    "GET",
    "/api/buildings/{id}"
  ],
  [
    "PATCH",
    "/api/buildings/{id}"
  ],
  [
    "DELETE",
    "/api/buildings/{id}"
  ],
  [
    "GET",
    "/api/floors"
  ],
  [
    "POST",
    "/api/floors"
  ],
  [
    "GET",
    "/api/floors/{id}"
  ],
  [
    "PATCH",
    "/api/floors/{id}"
  ],
  [
    "DELETE",
    "/api/floors/{id}"
  ],
  [
    "GET",
    "/api/zones"
  ],
  [
    "POST",
    "/api/zones"
  ],
  [
    "GET",
    "/api/zones/{id}"
  ],
  [
    "PATCH",
    "/api/zones/{id}"
  ],
  [
    "DELETE",
    "/api/zones/{id}"
  ],
  [
    "GET",
    "/api/space-types"
  ],
  [
    "POST",
    "/api/space-types"
  ],
  [
    "GET",
    "/api/space-types/{id}"
  ],
  [
    "PATCH",
    "/api/space-types/{id}"
  ],
  [
    "DELETE",
    "/api/space-types/{id}"
  ],
  [
    "GET",
    "/api/amenities"
  ],
  [
    "POST",
    "/api/amenities"
  ],
  [
    "GET",
    "/api/amenities/{id}"
  ],
  [
    "PATCH",
    "/api/amenities/{id}"
  ],
  [
    "DELETE",
    "/api/amenities/{id}"
  ],
  [
    "GET",
    "/api/spaces/{id}/layouts"
  ],
  [
    "POST",
    "/api/spaces/{id}/layouts"
  ],
  [
    "PATCH",
    "/api/spaces/{id}/layouts/{layoutId}"
  ],
  [
    "GET",
    "/api/spaces"
  ],
  [
    "POST",
    "/api/spaces"
  ],
  [
    "GET",
    "/api/spaces/{id}"
  ],
  [
    "PATCH",
    "/api/spaces/{id}"
  ],
  [
    "DELETE",
    "/api/spaces/{id}"
  ],
  [
    "POST",
    "/api/spaces/{id}/retire"
  ],
  [
    "GET",
    "/api/spaces/{id}/effective-policy"
  ],
  [
    "GET",
    "/api/booking-policies"
  ],
  [
    "POST",
    "/api/booking-policies"
  ],
  [
    "GET",
    "/api/booking-policies/{id}"
  ],
  [
    "PATCH",
    "/api/booking-policies/{id}"
  ],
  [
    "DELETE",
    "/api/booking-policies/{id}"
  ],
  [
    "GET",
    "/api/blackouts"
  ],
  [
    "POST",
    "/api/blackouts"
  ],
  [
    "GET",
    "/api/blackouts/{id}"
  ],
  [
    "PATCH",
    "/api/blackouts/{id}"
  ],
  [
    "DELETE",
    "/api/blackouts/{id}"
  ],
  [
    "POST",
    "/api/policies/evaluate"
  ],
  [
    "POST",
    "/api/ai/chat"
  ],
  [
    "POST",
    "/api/ai/assistant/chat"
  ],
  [
    "POST",
    "/api/ai/assistant/confirm"
  ],
  [
    "GET",
    "/api/files"
  ],
  [
    "POST",
    "/api/files"
  ],
  [
    "DELETE",
    "/api/files/{id}"
  ],
  [
    "GET",
    "/api/files/{id}/content"
  ],
  [
    "GET",
    "/api/availability/search"
  ],
  [
    "GET",
    "/api/bookings"
  ],
  [
    "POST",
    "/api/bookings"
  ],
  [
    "GET",
    "/api/bookings/{id}"
  ],
  [
    "PATCH",
    "/api/bookings/{id}"
  ],
  [
    "DELETE",
    "/api/bookings/{id}"
  ],
  [
    "POST",
    "/api/bookings/{id}/cancel"
  ],
  [
    "POST",
    "/api/booking-series/preview"
  ],
  [
    "POST",
    "/api/booking-series"
  ],
  [
    "POST",
    "/api/bookings/{id}/check-in"
  ],
  [
    "POST",
    "/api/bookings/{id}/check-out"
  ],
  [
    "POST",
    "/api/bookings/{id}/take-over"
  ],
  [
    "GET",
    "/api/bookings/{id}/history"
  ],
  [
    "GET",
    "/api/directory/users"
  ],
  [
    "GET",
    "/api/reports/utilisation"
  ],
  [
    "GET",
    "/api/reports/utilisation/timeseries"
  ],
  [
    "GET",
    "/api/reports/no-shows"
  ],
  [
    "GET",
    "/api/reports/intent-vs-actual"
  ],
  [
    "GET",
    "/api/reports/manager-attendance"
  ],
  [
    "GET",
    "/api/reports/peaks"
  ],
  [
    "GET",
    "/api/reports/underutilised"
  ],
  [
    "GET",
    "/api/audit-events"
  ],
  [
    "POST",
    "/api/itineraries"
  ],
  [
    "GET",
    "/api/vehicles"
  ],
  [
    "POST",
    "/api/vehicles"
  ],
  [
    "GET",
    "/api/presence/me"
  ],
  [
    "PUT",
    "/api/presence/me"
  ],
  [
    "PUT",
    "/api/presence/me/defaults"
  ],
  [
    "GET",
    "/api/presence/me/settings"
  ],
  [
    "PUT",
    "/api/presence/me/settings"
  ],
  [
    "GET",
    "/api/me/timed-plans"
  ],
  [
    "GET",
    "/api/me/timed-plans/{date}"
  ],
  [
    "PUT",
    "/api/me/timed-plans/{date}"
  ],
  [
    "GET",
    "/api/me/location-context"
  ],
  [
    "PUT",
    "/api/me/location-context"
  ],
  [
    "DELETE",
    "/api/me/location-context"
  ],
  [
    "GET",
    "/api/me/location-needs"
  ],
  [
    "POST",
    "/api/me/location-needs"
  ],
  [
    "POST",
    "/api/me/location-needs/suggestions"
  ],
  [
    "POST",
    "/api/me/location-needs/decisions"
  ],
  [
    "GET",
    "/api/me/timed-plans/{date}/stops/{stopId}/recommendations"
  ],
  [
    "PATCH",
    "/api/me/location-needs/{id}"
  ],
  [
    "DELETE",
    "/api/me/location-needs/{id}"
  ],
  [
    "GET",
    "/api/me/search-prefs"
  ],
  [
    "PUT",
    "/api/me/search-prefs"
  ],
  [
    "GET",
    "/api/me/workplace-profile"
  ],
  [
    "PUT",
    "/api/me/workplace-profile"
  ],
  [
    "GET",
    "/api/admin/workplace-zones"
  ],
  [
    "GET",
    "/api/admin/users/{userId}/staff-classification"
  ],
  [
    "PUT",
    "/api/admin/users/{userId}/staff-classification"
  ],
  [
    "GET",
    "/api/admin/users/{userId}/workplace-profile"
  ],
  [
    "PUT",
    "/api/admin/users/{userId}/workplace-profile"
  ],
  [
    "GET",
    "/api/me/notifications"
  ],
  [
    "GET",
    "/api/me/notifications/unread-count"
  ],
  [
    "POST",
    "/api/me/notifications/read-all"
  ],
  [
    "POST",
    "/api/me/notifications/{id}/read"
  ],
  [
    "GET",
    "/api/me/notification-preferences"
  ],
  [
    "PUT",
    "/api/me/notification-preferences"
  ],
  [
    "GET",
    "/api/me/notification-channels"
  ],
  [
    "GET",
    "/api/visitor-booking/settings"
  ],
  [
    "PUT",
    "/api/visitor-booking/settings"
  ],
  [
    "GET",
    "/api/visitor-booking/approvals"
  ],
  [
    "POST",
    "/api/visitor-booking/approvals/{id}/decision"
  ],
  [
    "GET",
    "/api/visits"
  ],
  [
    "POST",
    "/api/visits"
  ],
  [
    "POST",
    "/api/visits/walk-up"
  ],
  [
    "GET",
    "/api/visits/{id}"
  ],
  [
    "PATCH",
    "/api/visits/{id}"
  ],
  [
    "POST",
    "/api/visits/{id}/cancel"
  ],
  [
    "POST",
    "/api/visits/{id}/check-in"
  ],
  [
    "POST",
    "/api/visits/{id}/check-out"
  ],
  [
    "GET",
    "/api/admin/visits"
  ],
  [
    "GET",
    "/api/me/favourites"
  ],
  [
    "PUT",
    "/api/me/favourites/{spaceId}"
  ],
  [
    "DELETE",
    "/api/me/favourites/{spaceId}"
  ],
  [
    "GET",
    "/api/me/book-again"
  ],
  [
    "GET",
    "/api/me/booking-suggestions"
  ],
  [
    "POST",
    "/api/me/booking-suggestions/{key}/dismiss"
  ],
  [
    "GET",
    "/api/workgroups"
  ],
  [
    "POST",
    "/api/workgroups"
  ],
  [
    "GET",
    "/api/workgroups/{id}"
  ],
  [
    "PATCH",
    "/api/workgroups/{id}"
  ],
  [
    "DELETE",
    "/api/workgroups/{id}"
  ],
  [
    "POST",
    "/api/workgroups/{id}/members"
  ],
  [
    "DELETE",
    "/api/workgroups/{id}/members/{userId}"
  ],
  [
    "GET",
    "/api/workgroups/{id}/week"
  ],
  [
    "PUT",
    "/api/workgroups/{id}/guidance"
  ],
  [
    "GET",
    "/api/workgroups/{id}/bookings"
  ],
  [
    "GET",
    "/api/presence/users"
  ],
  [
    "GET",
    "/api/colleagues"
  ],
  [
    "GET",
    "/api/colleagues/{userId}/week"
  ],
  [
    "GET",
    "/api/colleagues/desk-locations"
  ],
  [
    "GET",
    "/api/colleagues/nominations"
  ],
  [
    "POST",
    "/api/colleagues/nominations"
  ],
  [
    "DELETE",
    "/api/colleagues/nominations/{colleagueUserId}"
  ],
  [
    "GET",
    "/api/colleagues/nominations/bookings"
  ],
  [
    "GET",
    "/api/floors/{id}/bookings"
  ],
  [
    "GET",
    "/api/floors/{id}/plan"
  ],
  [
    "PUT",
    "/api/floors/{id}/plan"
  ],
  [
    "DELETE",
    "/api/floors/{id}/plan"
  ],
  [
    "POST",
    "/api/spaces/{id}/plan-removal/preview"
  ],
  [
    "POST",
    "/api/spaces/{id}/plan-removal/confirm"
  ],
  [
    "POST",
    "/api/floors/{id}/plan-removal/preview"
  ],
  [
    "POST",
    "/api/floors/{id}/plan-removal/confirm"
  ],
  [
    "GET",
    "/api/floors/{id}/geometry"
  ],
  [
    "PUT",
    "/api/floors/{id}/geometry"
  ],
  [
    "GET",
    "/api/floors/{id}/twin-status"
  ],
  [
    "PUT",
    "/api/floors/{id}/twin-sensors"
  ],
  [
    "GET",
    "/api/floors/{id}/plan/content"
  ],
  [
    "GET",
    "/api/admin/insights/overview"
  ],
  [
    "POST",
    "/api/admin/insights/summary"
  ],
  [
    "GET",
    "/api/admin/inventory/export"
  ],
  [
    "GET",
    "/api/admin/inventory/import/template"
  ],
  [
    "POST",
    "/api/admin/inventory/import/preview"
  ],
  [
    "POST",
    "/api/admin/inventory/import/commit"
  ],
  [
    "GET",
    "/api/admin/inventory/import/results/{reportId}"
  ],
  [
    "GET",
    "/api/admin/bookings/export"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/home-webpart-options"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/home-webparts"
  ],
  [
    "PUT",
    "/api/tenants/{tenantSlug}/home-webparts"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/entity"
  ],
  [
    "PATCH",
    "/api/tenants/{tenantSlug}/entity"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/entities"
  ],
  [
    "POST",
    "/api/tenants/{tenantSlug}/entities"
  ],
  [
    "POST",
    "/api/tenants/{tenantSlug}/entity/lifecycle"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/member-candidates"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/group-access/status"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/directory-groups"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/directory-groups/{groupId}"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/group-access/roles"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/group-bindings"
  ],
  [
    "POST",
    "/api/tenants/{tenantSlug}/group-bindings"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/group-bindings/{bindingId}"
  ],
  [
    "PATCH",
    "/api/tenants/{tenantSlug}/group-bindings/{bindingId}"
  ],
  [
    "DELETE",
    "/api/tenants/{tenantSlug}/group-bindings/{bindingId}"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/members/{memberId}/access-sources"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/members"
  ],
  [
    "POST",
    "/api/tenants/{tenantSlug}/members"
  ],
  [
    "PATCH",
    "/api/tenants/{tenantSlug}/members/{memberId}"
  ],
  [
    "DELETE",
    "/api/tenants/{tenantSlug}/members/{memberId}"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/invites"
  ],
  [
    "POST",
    "/api/tenants/{tenantSlug}/invites"
  ],
  [
    "POST",
    "/api/tenants/{tenantSlug}/invites/{inviteId}/revoke"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/roles"
  ],
  [
    "POST",
    "/api/tenants/{tenantSlug}/roles"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/features"
  ],
  [
    "PATCH",
    "/api/tenants/{tenantSlug}/features/{moduleKey}"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/settings"
  ],
  [
    "PATCH",
    "/api/tenants/{tenantSlug}/settings"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/workplace-options"
  ],
  [
    "PATCH",
    "/api/tenants/{tenantSlug}/workplace-options"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/customer-settings"
  ],
  [
    "PATCH",
    "/api/tenants/{tenantSlug}/customer-settings"
  ],
  [
    "PUT",
    "/api/tenants/{tenantSlug}/customer-logo"
  ],
  [
    "DELETE",
    "/api/tenants/{tenantSlug}/customer-logo"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/audit"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/directory/search"
  ],
  [
    "PATCH",
    "/api/tenants/{tenantSlug}/roles/{roleId}"
  ],
  [
    "DELETE",
    "/api/tenants/{tenantSlug}/roles/{roleId}"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/elevations"
  ],
  [
    "POST",
    "/api/tenants/{tenantSlug}/elevations"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/elevations/{elevationId}"
  ],
  [
    "POST",
    "/api/tenants/{tenantSlug}/elevations/{elevationId}/resolve"
  ],
  [
    "GET",
    "/api/credential-types"
  ],
  [
    "POST",
    "/api/credential-types"
  ],
  [
    "PATCH",
    "/api/credential-types/{id}"
  ],
  [
    "GET",
    "/api/credentials/me"
  ],
  [
    "POST",
    "/api/credentials/me"
  ],
  [
    "GET",
    "/api/credentials/{id}/document"
  ],
  [
    "GET",
    "/api/admin/credentials"
  ],
  [
    "POST",
    "/api/admin/credentials/{id}/review"
  ],
  [
    "GET",
    "/api/tenants/{tenantSlug}/email-templates"
  ],
  [
    "PUT",
    "/api/tenants/{tenantSlug}/email-templates/{type}"
  ],
  [
    "DELETE",
    "/api/tenants/{tenantSlug}/email-templates/{type}"
  ],
  [
    "PATCH",
    "/api/tenants/{tenantSlug}/email-templates/permissions"
  ],
  [
    "POST",
    "/api/tenants/{tenantSlug}/email-templates/preview"
  ]
];
